<template>
  <q-card flat>
    <div v-if="showYear" class="row justify-center q-ma-md">
      <q-btn class="col-2" flat icon="keyboard_arrow_left" @click="changeYear(-1)" />
      <div v-if="!editableYear" class="col-8 text-center self-center text-h6">
        {{ year }}
      </div>
      <input v-else v-model.number="year" type="text" @change="onChange()">
      <q-btn class="col-2" flat icon="keyboard_arrow_right" @click="changeYear(+1)" />
    </div>
    <div class="row q-mb-md">
      <q-btn v-for="(month, i) in monthsByLang" :key="month" :flat="currentMonth !== month"
        class="col-4 q-pa-xs q-mt-md q-mb-md"  :outline="currentMonth === month" :disable="inRange(i, year)"
        :color="currentMonth === month ? 'primary' : ''" @click="selectMonth(i, true)">
        {{ month }}
      </q-btn>
    </div>
  </q-card>
</template>

<script>
import languages from './languages'
import monthPicker from './month-picker'

export default {
  name: 'MonthPicker',
  mixins: [monthPicker],
  data() {
    return {
      currentMonthIndex: null,
      year: new Date().getFullYear()
    }
  },
  computed: {
    monthsByLang: function() {
      if (this.months !== null && this.months.length === 12) {
        return this.months
      }
      return languages[this.lang]
    },
    // eslint-disable-next-line vue/return-in-computed-property
    currentMonth: function() {
      if (this.currentMonthIndex !== null) {
        return this.monthsByLang[this.currentMonthIndex]
      }
    },
    date: function() {
      const month = this.monthsByLang.indexOf(this.currentMonth) + 1
      const date = new Date(`${this.year}/${month}/01`)
      const year = date.getFullYear()

      return {
        from: date,
        to: new Date(year, month, 1),
        month: this.monthsByLang[month - 1],
        monthIndex: month,
        year: year
      }
    }
  },
  mounted() {
    if (this.defaultMonth) {
      this.selectMonth(this.defaultMonth - 1)
    } else if (!this.noDefault) {
      this.selectMonth(0)
    }

    if (this.defaultYear) {
      this.year = this.defaultYear
    }
  },
  methods: {
    inRange(month, year) {
      return this.range ? !eval(`(${this.range})(${new Date(year, month).getTime()})`) : false
    },
    onChange() {
      this.$emit('change', this.date)
    },
    selectMonth(index, input = false) {
      const isAlreadySelected = this.currentMonthIndex === index
      if (this.clearable && isAlreadySelected) {
        this.currentMonthIndex = null
        this.$emit('clear')
        return
      }

      if (this.isAlreadySelected) {
        return
      }

      this.currentMonthIndex = index
      this.onChange()
      if (input) {
        this.$emit('input', this.date)
      }
    },
    changeYear(value) {
      this.year += value
      this.onChange()
      this.$emit('change-year', this.year)
    }
  }
}
</script>